import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CmisComponent} from './cmis/cmis.component';
import {icons} from '../../ui/icons';
import {AcheteurComponent} from './acheteur/acheteur.component';
import {OffersComponent} from './offers/offers.component';
import {ProjetProgComponent} from './projet-prog/projet-prog.component';
import {OfferDetailsComponent} from './offers/offer-details/offer-details.component';
import {QnaComponent} from './qna/qna.component';
import {FaqComponent} from './faq/faq.component';
import {FaqCardComponent} from './faq/faq-card/faq-card.component';
import {ProjetProgDetailsComponent} from './projet-prog/projet-prog-details/projet-prog-details.component';
import {CmisCardComponent} from './cmis/cmis-card/cmis-card.component';
import {QnaCardComponent} from './qna/qna-card/qna-card.component';
import {AccueilComponent} from './accueil/accueil.component';
import {ConsultationsComponent} from './consultations/consultations.component';
import {ConsultationDetailsComponent} from './consultations/consultation-details/consultation-details.component';
import {NewsCardComponent} from './news/news-card/news-card.component';
import {ContactTerminologieComponent} from './contact-terminologie/contact-terminologie.component';
import {NewsComponent} from './news/news.component';
import {AdminAnnouncementComponent} from './admin-announcement/admin-announcement.component';
import {BuyerAnnouncementComponent} from './buyer-announcement/buyer-announcement.component';
import {BuyerAnnouncementCardComponent} from './buyer-announcement/buyer-announcement-card/buyer-announcement-card.component';
import {AdminAnnouncementCardComponent} from './admin-announcement/admin-announcement-card/admin-announcement-card.component';
import {TousLesStatistiquesComponent} from './accueil/statistiques/tous-les-statistiques/tous-les-statistiques.component';
import {FournissuerDetailComponent} from './fournissuer-detail/fournissuer-detail.component';
import {FournisseurComponent} from './fournisseur/fournisseur.component';
import {OutletComponent} from 'src/app/modules/widget/components/outlet/outlet.component';
import {EtatDemandeComponent} from './etat-demande/etat-demande.component';
import {RecapInscrptionAcheteurComponent} from './acheteur/recap-inscrption-acheteur/recap-inscrption-acheteur.component';
import {RecapInscriptionFournisseurComponent} from './fournisseur/recap-inscription-fournisseur/recap-inscription-fournisseur.component';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {CataloguePComponent} from './catalogue-p/catalogue-p.component';
import {HierachieClassPComponent} from './hierachie-class-p/hierachie-class-p.component';
import {CatalogueClassPComponent} from './catalogue-class-p/catalogue-class-p.component';
import {CatClasPListComponent} from './catalogue-class-p/cat-clas-p-list/cat-clas-p-list.component';
import {FicheListSoumissionairesComponent} from './offers/fiche-list-soumissionaires/fiche-list-soumissionaires.component';
import {FicheResultatOuvertureComponent} from './offers/fiche-resultat-ouverture/fiche-resultat-ouverture.component';
import {ListFilterCertiffourComponent} from './fournisseur/certif-fournisseur/list-filter-certiffour/list-filter-certiffour.component';
import {AddCertifFournisseurComponent} from './fournisseur/add-certif-fournisseur/add-certif-fournisseur.component';
import {DetailEtatAcheteurComponent} from './etat-demande/detail-etat-acheteur/detail-etat-acheteur.component';
import {ListCertifAcheteurComponent} from './acheteur/list-certif-acheteur/list-certif-acheteur.component';
import {AddCertifAcheteurComponent} from './acheteur/add-certif-acheteur/add-certif-acheteur.component';
import {EtatInscriptionFournComponent} from './fournisseur/etat-inscription-fourn/etat-inscription-fourn.component';
import {TableEtatEditionComponent} from './table-etat-edition/table-etat-edition.component';

export const paths = {
    parent: 'portail',
};

const routes: Routes = [];

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',

                component: AccueilComponent,
                data: {
                    title: 'TUNEPS',
                    icon: 'home',
                    breadcrumb: 'Accueil',
                },
            },
            // {
            //   path: "login",

            //   component: LoginComponent,
            //   data: {

            //     title: "Se connecter",
            //     icon: "home",
            //     breadcrumb: "Se connecter",
            //   },
            // },
            // {
            //   path: "certificat",
            //   component: LoginComponent,
            //   data: {
            //     title: "certificat",
            //   },
            // },
            {
                path: 'cmis',
                component: CmisComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'cmis',
                    icon: icons.reception,
                },
            },
            {
                path: 'etat/details_info_four/:bizRegNo',
                component: EtatInscriptionFournComponent,
                data: {
                    title: 'détails informations',
                    breadcrumb: 'Informations Fournisseurs',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmis_Lois',
                component: OutletComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'Lois',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        // redirectTo: '/portail/cmis_Lois/A',
                        component: CmisComponent,
                        data: {
                            type: 'A',
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },

                    {
                        path: 'cmiscard_loi/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_loi',
                            breadcrumb: 'cmiscard_loi',
                            icon: icons.type,
                        },
                    },
                ],
            },
            {
                path: 'cmis_Decrets',
                component: OutletComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'Decrets',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: CmisComponent,
                        data: {
                            type: 'B',
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'cmiscard_Decrets/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_Decrets',
                            breadcrumb: 'cmiscard_Decrets',
                            icon: icons.reception,
                        },
                    },
                ],
            },

            {
                path: 'cmis_Arretes',
                component: OutletComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'Arretes',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: CmisComponent,
                        data: {
                            type: 'C',
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'cmiscard_Arretes/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_Arretes',
                            breadcrumb: 'cmiscard_Arretes',
                            icon: icons.reception,
                        },
                    },
                ],
            },
            {
                path: 'cmis_manuel',
                component: OutletComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'Manuel_utilisations',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: CmisComponent,
                        data: {
                            type: 'E',
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'cmiscard_Manuel/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_Manuel',
                            breadcrumb: 'cmiscard_Manuel',
                            icon: icons.reception,
                        },
                    },
                ],
            },
            {
                path: 'cmis_Autres',
                component: OutletComponent,
                data: {
                    title: 'cmis',
                    breadcrumb: 'Autres',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: CmisComponent,
                        data: {
                            type: 'Z',
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'cmiscard_Autres/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_Autres',
                            breadcrumb: 'cmiscard_Autres',
                            icon: icons.reception,
                        },
                    },
                ],
            },

            {
                path: 'acheteur',

                component: OutletComponent,
                data: {
                    title: 'add_acheteur',
                    breadcrumb: 'add_acheteur',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: AcheteurComponent,
                        data: {
                            title: 'add_acheteur',
                            breadcrumb: 'add_acheteur',
                            icon: icons.reception,
                        },
                    },
                    {
                        path: 'details',
                        component: RecapInscrptionAcheteurComponent,
                        data: {
                            title: 'details_acheteur',
                            breadcrumb: 'details_acheteur',
                            icon: icons.reception,
                        },
                    },
                    {
                        path: 'cmiscard_Arretes/:id',
                        component: CmisCardComponent,
                        data: {
                            title: 'cmiscard_Arretes',
                            breadcrumb: 'cmiscard_Arretes',
                            icon: icons.reception,
                        },
                    },
                ],
            },
            {
                path: 'etat',

                component: EtatDemandeComponent,
                data: {
                    title: 'etat',
                    breadcrumb: 'etat',
                    icon: icons.reception,
                },
            },

            {
                path: 'recapetatachteur/:instRcvNo',

                component: DetailEtatAcheteurComponent,
                data: {
                    title: 'recapetatachteur',
                    breadcrumb: 'recapetatachteur',
                    icon: icons.reception,
                },
            },
            {
                path: 'fournisInscription',

                component: FournisseurComponent,
                data: {
                    title: 'add_fournisseur',
                    breadcrumb: 'add_fournisseur',
                    icon: icons.reception,
                },
            },
            {
                path: 'certif_fournisseur',

                component: OutletComponent,
                data: {
                    title: 'Certificat fournisseur',
                    breadcrumb: 'Enregistrement Certificat Electronique Fournisseur',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: ListFilterCertiffourComponent,
                    },
                    {
                        path: 'add_certif/:bizRegNo',
                        component: AddCertifFournisseurComponent,
                        data: {
                            title: 'add_certif',
                            breadcrumb:
                                'Enregistrement Nouveau Certificat ou Certificat Supplémentaire',
                            icon: 'assignment_ind',
                        },
                    },
                ],
            },
            {
                path: 'certif_acheteur',

                component: OutletComponent,
                data: {
                    title: 'Certificat acheteur',
                    breadcrumb: 'Enregistrement Certificat Electronique Acheteur',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: ListCertifAcheteurComponent,
                    },
                    {
                        path: 'add_certif_ach/:bizRegNo',
                        component: AddCertifAcheteurComponent,
                        data: {
                            title: 'add_certif',
                            breadcrumb:
                                'Enregistrement Nouveau Certificat ou Certificat Supplémentaire',
                            icon: 'assignment_ind',
                        },
                    },
                ],
            },
            {
                path: 'recapfournisseur/:id',
                component: RecapInscriptionFournisseurComponent,
                data: {
                    title: 'recap_fournisseur',
                    breadcrumb: 'recap_fournisseur',
                    icon: icons.reception,
                },
            },
            {
                path: 'news',

                component: OutletComponent,
                data: {
                    title: 'Actualités',
                    breadcrumb: 'Actualités',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: NewsComponent,
                        data: {
                            title: 'Actualités',
                            breadcrumb: 'Actualités',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'details/:id',
                        component: NewsCardComponent,
                        data: {
                            title: 'details',
                            breadcrumb: 'details',
                            icon: icons.edit,
                        },
                    },
                ],
            },

            {
                path: 'administrator-announcements',

                component: OutletComponent,
                data: {
                    title: 'administrator-announcements',
                    breadcrumb: 'Annonces administrateur',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: AdminAnnouncementComponent,
                        data: {
                            title: 'administrator-announcements',
                            breadcrumb: 'Annonces administrateur',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'details/:id',
                        component: AdminAnnouncementCardComponent,
                        data: {
                            title: 'details',
                            breadcrumb: 'details',
                            icon: icons.edit,
                        },
                    },
                ],
            },

            {
                path: 'public-buyer-announcements',

                component: OutletComponent,
                data: {
                    title: 'public-buyer-announcements',
                    breadcrumb: 'Annonces de l\'acheteur public',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: BuyerAnnouncementComponent,
                        data: {
                            title: 'public-buyer-announcements',
                            breadcrumb: 'Annonces de l\'acheteur public',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'details',
                        component: BuyerAnnouncementCardComponent,
                        data: {
                            title: 'details',
                            breadcrumb: 'details',
                            icon: icons.edit,
                        },
                    },
                ],
            },

            {
                path: 'catalogue',
                component: CataloguePComponent,
                data: {
                    title: 'Catalogue',
                    breadcrumb: 'Catalogue',
                },
            },
            {
                path: 'hierachie',
                component: HierachieClassPComponent,
                data: {
                    title: 'hierachie',
                    breadcrumb: 'hierachie',
                },
            },
            {
                path: 'Classification',
                component: CatalogueClassPComponent,
                data: {
                    title: 'Classification',
                    breadcrumb: 'Classification',
                },
            },

            {
                path: 'Prodlist/:id',
                component: CatClasPListComponent,
                data: {
                    title: 'listprodclass',
                    breadcrumb: 'listprodclass',
                },
            },

            {
                path: 'consultations',
                component: ConsultationsComponent,
                data: {
                    title: 'consultations',
                    breadcrumb: 'Consultations',
                },
            },

            {
                path: 'touslesstatistiques',
                component: TousLesStatistiquesComponent,
                data: {
                    title: 'touslesstatistiques',
                    breadcrumb: 'Tous les statistiques',
                },
            },
            {
                path: 'consultationdetails',
                component: ConsultationDetailsComponent,
                data: {
                    title: 'consultationdetails',
                    breadcrumb: 'Consultation',
                },
            },

            // {
            //   path: "offerdetails/:epBidMasterId/:bidNo",
            //   component: OfferDetailsComponent,
            //   data: {
            //     title: "offerdetails",
            //     breadcrumb: "Avis d'A.O",
            //     icon: icons.reception,
            //   },
            // },

            {
                path: 'qna',
                component: OutletComponent,
                data: {
                    title: 'qna',
                    breadcrumb: 'qna',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: '',
                        component: QnaComponent,
                        data: {
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'qnacard',
                        component: QnaCardComponent,
                        data: {
                            title: 'qnacard',
                            breadcrumb: 'qnacard',
                            icon: icons.reception,
                        },
                    },
                ],
            },
            {
                path: 'detailfournisseur',
                component: FournissuerDetailComponent,
                data: {
                    title: 'Liste_des_fournisseurs',
                    breadcrumb: 'Liste_des_fournisseurs',
                    icon: icons.reception,
                },
            },
            {
                path: 'contact',
                component: ContactTerminologieComponent,
                data: {
                    title: 'contact',
                    breadcrumb: 'contact',
                    icon: icons.reception,
                },
            },
            {
                path: 'Terminologie',
                component: ContactTerminologieComponent,
                data: {
                    title: 'contact',
                    breadcrumb: 'Terminologie_f',
                    icon: icons.reception,
                },
            },

            {
                path: 'Termes_et_conditions',
                component: ContactTerminologieComponent,
                data: {
                    title: 'Termes_et_conditions',
                    breadcrumb: 'Termes_et_conditions',
                    icon: icons.reception,
                },
            },
            {
                path: 'A_propos_du_systeme',
                component: ContactTerminologieComponent,
                data: {
                    title: 'A_propos_du_systeme',
                    breadcrumb: 'A_propos_du_systeme',
                    icon: icons.reception,
                },
            },
            {
                path: 'Videotheque',
                component: ContactTerminologieComponent,
                data: {
                    title: 'contact',
                    breadcrumb: 'Videothéque',
                    icon: icons.reception,
                },
            },
            {
                path: 'faq',
                component: OutletComponent,
                data: {
                    title: 'faq',
                    breadcrumb: 'faq',
                    icon: icons.reception,
                },

                children: [
                    {
                        path: '',
                        component: FaqComponent,
                        data: {
                            title: '',
                            breadcrumb: '',
                            icon: icons.type,
                        },
                    },
                    {
                        path: 'faqcard',
                        component: FaqCardComponent,
                        data: {
                            title: 'faqcard',
                            breadcrumb: 'Consultation_detaillée_de_la_FAQ',
                            icon: icons.reception,
                        },
                    },
                ],
            },

            {
                path: 'projets',
                canActivate: [NgxPermissionsGuard],
                component: OutletComponent,
                data: {
                    title: 'projets',
                    breadcrumb: 'Projets Programmés',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: ProjetProgComponent,

                        data: {
                            title: 'projets',
                            breadcrumb: 'Projets Programmés',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'projetdetails/:epPlanMasterId',
                        component: ProjetProgDetailsComponent,
                        data: {
                            title: 'projet',
                            breadcrumb: 'Projet',
                            icon: icons.reception,
                        },
                    },
                ],
            },

            {
                path: 'offres',
                canActivate: [],
                component: OutletComponent,
                data: {
                    title: 'offres',
                    breadcrumb: 'Appels d\'offres',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: OffersComponent,
                        data: {
                            title: 'offres',
                            breadcrumb: 'Appels d\'offres',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'details/:epBidMasterId/:bidNo',
                        data: {
                            title: 'Fiche détails',
                            breadcrumb: 'Fiche détails',
                            icon: 'assignment_ind',
                        },
                        children: [
                            {
                                path: '',
                                component: OfferDetailsComponent,
                            },
                            {
                                path: 'listSoumissionaires',
                                component: FicheListSoumissionairesComponent,
                                data: {
                                    title: 'List soumissionaire(s) retenu(s)',
                                    breadcrumb: 'List soumissionaire(s) retenu(s)',
                                    icon: 'assignment_ind',
                                },
                            },
                            {
                                path: 'resultatouverture',
                                component: FicheResultatOuvertureComponent,
                                data: {
                                    title: 'Voir les résultats d\'ouverture des offres',
                                    breadcrumb: 'Voir les résultats d\'ouverture des offres',
                                    icon: 'assignment_ind',
                                    type: 'ao'
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'consultations',

                component: OutletComponent,
                data: {
                    title: 'consultations',
                    breadcrumb: 'Consultations',
                    icon: 'assignment_ind',
                },
                children: [
                    {
                        path: '',
                        component: ConsultationsComponent,

                        data: {
                            title: 'consultations',
                            breadcrumb: 'Consultations',
                            icon: 'assignment_ind',
                        },
                    },
                    {
                        path: 'consultationdetails/:spShopMasterId/:shopNo',
                        data: {
                            title: 'Détails consultation',
                            breadcrumb: 'Détails consultation',
                            icon: icons.reception,
                        },
                        children: [
                            {
                                path: '',
                                component: ConsultationDetailsComponent,
                            },
                            {
                                path: 'listSoumissionaires',
                                component: FicheListSoumissionairesComponent,
                                data: {
                                    title: 'List soumissionaire(s) retenu(s)',
                                    breadcrumb: 'List soumissionaire(s) retenu(s)',
                                    icon: 'assignment_ind',
                                },
                            },
                            {
                                path: 'resultatouverture',
                                component: FicheResultatOuvertureComponent,
                                data: {
                                    title: 'Voir les résultats d\'ouverture des offres',
                                    breadcrumb: 'Voir les résultats d\'ouverture des offres',
                                    icon: 'assignment_ind',
                                    type: 'shop'
                                },
                            },
                        ],
                    },
                ],
            },

            {
                path: 'faqcard',
                component: FaqCardComponent,
                data: {
                    title: 'faqcard',
                    breadcrumb: 'Consultation_detaillée_de_la_FAQ',
                    icon: icons.reception,
                },
            },

            // {
            //   path: "projetdetails",
            //   component: ProjetProgDetailsComponent,
            //   data: {
            //     title: "reception",
            //     breadcrumb: "Projet",
            //     icon: icons.reception,
            //   },
            // },

            {
                path: 'cmiscard',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard',
                    breadcrumb: '',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmiscard_loi',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard_loi',
                    breadcrumb: 'cmiscard_loi',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmiscard_Decrets',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard_Decrets',
                    breadcrumb: 'cmiscard_Decrets',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmiscard_Arretes',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard_Arretes',
                    breadcrumb: 'cmiscard_Arretes',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmiscard_Manuel',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard_Manuel',
                    breadcrumb: 'cmiscard_Manuel',
                    icon: icons.reception,
                },
            },
            {
                path: 'cmiscard_Autres',
                component: CmisCardComponent,
                data: {
                    title: 'cmiscard_Autres',
                    breadcrumb: 'cmiscard_Autres',
                    icon: icons.reception,
                },
            },

            {
                path: 'qnacard',
                component: QnaCardComponent,
                data: {
                    title: 'qnacard',
                    breadcrumb: 'qnacard',
                    icon: icons.reception,
                },
            },
            {
                path: 's',
                data: {
                    title: 'Services',
                    breadcrumb: 'Services',
                    icon: icons.reception,
                },
                children: [
                    {
                        path: 'i',
                        data: {
                            title: 'Indicateurs performances',
                            breadcrumb: 'Indicateurs performances',
                            icon: icons.type,
                        },
                        children: [
                            {
                                path: 'u',
                                component: TableEtatEditionComponent,
                                data: {
                                    type: 'utilisateurs',
                                    title: 'Utilisateurs',
                                    breadcrumb: 'Utilisateurs',
                                    icon: icons.type,
                                },
                            },
                            {
                                path: 'ao',
                                component: TableEtatEditionComponent,
                                data: {
                                    type: 'ao',
                                    title: 'Appel offres',
                                    breadcrumb: 'Appel offres',
                                    icon: icons.type,
                                },
                            },
                            {
                                path: 'ce',
                                component: TableEtatEditionComponent,
                                data: {
                                    type: 'ce',
                                    title: 'Contrats électroniques',
                                    breadcrumb: 'Contrats électroniques',
                                    icon: icons.type,
                                },
                            },
                        ],
                    },
                ],
            },
        ]),
    ],
    exports: [RouterModule],
})
export class PortailRoutingModule {
}
